// reducer action 생성 헬퍼함수입니다.
// state 가 계층적으로 존재할때 key 를 자동으로 바인딩 해주는 기능

import { PayloadAction } from "@reduxjs/toolkit";

// 타입 안전한 경로를 위한 타입 유틸리티
export type PathsToStringProps<T> = T extends object
  ? {
    [K in keyof T]: K extends string
    ? T[K] extends object
    ? K | `${K}.${PathsToStringProps<T[K]>}`
    : K
    : never;
  }[keyof T & string]
  : never;

// 경로에 대한 값 타입을 추출하는 타입
export type TypeFromPath<T, P extends string> = P extends `${infer K}.${infer R}`
  ? K extends keyof T
  ? TypeFromPath<T[K], R>
  : never
  : P extends keyof T
  ? T[P]
  : never;

// 경로와 값 타입을 가진 페이로드 타입 생성
export type PathPayload<T> = {
  path: PathsToStringProps<T>;
  value: any;
};

// 슬라이스 이름과 상태를 바탕으로 경로와 타입을 바인딩하는 함수
export function bindSlicePath<SliceName extends string, StateType extends object>(sliceName: SliceName) {
  type SliceStatePath = PathsToStringProps<StateType>;

  // 슬라이스 내의 경로와 값을 받는 액션 생성자
  function createPathAction<P extends SliceStatePath>(
    path: P,
    value: TypeFromPath<StateType, P>
  ) {
    return {
      path: `${sliceName}.${path}`,
      value
    };
  }

  return {
    createPathAction
  };
}

// 값 설정을 위한 리듀서 함수
export const setValue = <T extends object>(state: T, action: PayloadAction<PathPayload<T>>) => {
  const { path, value } = action.payload;
  const keys = path.split('.');

  let current: any = state;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!current[key]) {
      current[key] = {};
    }
    current = current[key];
  }

  const lastKey = keys[keys.length - 1];
  current[lastKey] = value;

};

/**
 * Json 데이터에서 중첩된 객체의 경로를 전달하면 값을 반환해 주는 메서드
 * @param json 
 * @param path 
 * @returns 
 */
export const getValueFromJson = <T extends object>(json: T, path: string) => {
  if (!json) {
    return undefined;
  }

  const keys = path.split('.');
  let current: any = json;

  for (const key of keys) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }
    current = current[key];
  }
  // console.log(path, current);



  return current;
}